// Pure route-access decisions (no Firebase), used by the router guard.
export const STAFF_ROLES = ['admin', 'superadmin', 'payroll']

// Where each role lands by default
export function homeFor(role) {
  if (STAFF_ROLES.includes(role)) return { name: 'AdminDashboard' }
  if (role === 'user' || role === 'applicant') return { name: 'MyApplications' }
  if (role === 'employee') return { name: 'MyPayStubs' }
  return { name: 'Home' }
}

// Only follow redirects to pages on this site (never "//evil.com" or "https://...")
export function safeRedirect(path) {
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') ? path : null
}

export function requiresLogin(to) {
  return to.matched.some(r => r.meta.requiresAuth)
}

// true to allow, or a route to redirect to. `claims` is { role, access } or null when signed out.
// (A blocked/removed login is signed out by the guard before this is called.)
export function decideAccess(to, claims) {
  if (!requiresLogin(to)) return true
  if (!claims) return { name: 'Login', query: { redirect: to.fullPath } }

  // Allowed roles from the nearest route that declares them (children inherit the parent's)
  const declaring = [...to.matched].reverse().find(r => r.meta.roles || r.meta.role)
  const allowed = declaring ? (declaring.meta.roles || [declaring.meta.role]) : null
  if (allowed && !allowed.includes(claims.role)) {
    const home = homeFor(claims.role)
    // Never bounce back to the page being refused
    return home.name === to.name ? { name: 'Home' } : home
  }
  return true
}
